export default __webpack_public_path__ + "static/media/svg-11.8fb8a335.svg";